import React from "react";
import PropTypes from "prop-types";
import { Cloud } from "lucide-react";
import logoImage from "../assets/logo/Logo-E3.png";

const Logo = ({ className = "h-16 w-auto" }) => (
  <button
    type="button"
    onClick={() => (window.location.href = "/")}
    className="flex items-center gap-2 text-white font-bold text-xl select-none focus:outline-none"
    aria-label="CloudMortgage Home"
  >
    <img
      src={logoImage}
      alt="CloudMortgage.io"
      className={`w-auto max-w-full ${className} object-contain`}
      onError={(e) => {
        e.target.style.display = "none";
        e.target.nextSibling.style.display = "flex";
      }}
    />
    <div className="hidden items-center gap-2">
      <Cloud className="h-8 w-8 text-sky-500" />
      <span>CLOUDMORTGAGE.io</span>
    </div>
  </button>
);

Logo.propTypes = {
  className: PropTypes.string,
};

export default Logo;
